module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-content"
  }, [_c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Тип получателя",
      "required": true,
      "name": "recipient_type",
      "id": "recipient_type",
      "error": _vm.errors.first('recipient_type'),
      "disabled": _vm.blocked,
      "inline": "inline",
      "dirty": _vm.dirtyObj.type
    },
    on: {
      "change": _vm.changeType,
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "type", $event)
      }
    },
    model: {
      value: (_vm.customer.type),
      callback: function($$v) {
        _vm.$set(_vm.customer, "type", $$v)
      },
      expression: "customer.type"
    }
  }, [_c('option', {
    domProps: {
      "value": '1'
    }
  }, [_vm._v("Юридическое лицо")]), _c('option', {
    domProps: {
      "value": '3'
    }
  }, [_vm._v("Индивидуальный предприниматель")]), _c('option', {
    domProps: {
      "value": '2'
    }
  }, [_vm._v("Физическое лицо")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.customer && !!([1, 3].indexOf(parseInt(_vm.customer.type)) + 1)),
      expression: "customer && !!([1,3].indexOf(parseInt(customer.type))+1)"
    }]
  }, [_c('ZInputAutocomplete', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': !!([1, 3].indexOf(parseInt(_vm.customer.type)) + 1)
      }),
      expression: "{'required': !!([1,3].indexOf(parseInt(customer.type))+1)}"
    }],
    ref: "inn",
    attrs: {
      "update-on-input": true,
      "label": "ИНН",
      "items": _vm.customersUl,
      "callback": _vm.searchCustomerByInn,
      "length-on-search": 3,
      "display-property": "inn",
      "display-property-list": "ul_inn_label",
      "property": "inn",
      "default": _vm.customer.inn,
      "required": !!([1, 3].indexOf(parseInt(_vm.customer.type)) + 1),
      "name": "recipient_inn",
      "id": "recipient_inn",
      "error": _vm.errors.first('recipient_inn'),
      "data-vv-name": "recipient_inn",
      "data-vv-as": ' ',
      "inline": "inline",
      "disabled": _vm.blocked,
      "dirty": _vm.dirtyObj.inn
    },
    on: {
      "select": _vm.selectCustomer,
      "clear": _vm.clearCustomer,
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "inn", $event)
      }
    },
    model: {
      value: (_vm.customer.inn),
      callback: function($$v) {
        _vm.$set(_vm.customer, "inn", $$v)
      },
      expression: "customer.inn"
    }
  }), _c('z-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasInn),
      expression: "hasInn"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': !!([1, 3].indexOf(parseInt(_vm.customer.type)) + 1)
      }),
      expression: "{'required': !!([1,3].indexOf(parseInt(customer.type))+1)}"
    }],
    attrs: {
      "label": "Наименование",
      "required": !!([1, 3].indexOf(parseInt(_vm.customer.type)) + 1),
      "name": "recipient_name",
      "id": "recipient_name",
      "disabled": !_vm.customer.allow_edit || _vm.blocked,
      "error": _vm.errors.first('recipient_name'),
      "data-vv-name": "recipient_name",
      "data-vv-as": ' ',
      "inline": "inline",
      "dirty": _vm.dirtyObj.name
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "name", $event)
      }
    },
    model: {
      value: (_vm.customer.name),
      callback: function($$v) {
        _vm.$set(_vm.customer, "name", $$v)
      },
      expression: "customer.name"
    }
  }), (parseInt(_vm.customer.type) != 3) ? _c('z-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasInn),
      expression: "hasInn"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (parseInt(_vm.customer.type) == 1 ? 'required|max:9|min:9' : ''),
      expression: "parseInt(customer.type) == 1 ? 'required|max:9|min:9' : ''"
    }],
    attrs: {
      "name": "recipient_kpp",
      "id": "recipient_kpp",
      "label": "КПП",
      "error": _vm.errors.first('recipient_kpp'),
      "minlength": 9,
      "maxlength": 9,
      "disabled": (!_vm.customer.allow_edit || _vm.blocked) && !_vm.customer.allow_edit_kpp,
      "type": "number",
      "required": parseInt(_vm.customer.type) == 1 ? true : false,
      "data-vv-name": "recipient_kpp",
      "data-vv-as": ' ',
      "inline": "inline",
      "dirty": _vm.dirtyObj.kpp
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "kpp", $event)
      }
    },
    model: {
      value: (_vm.customer.kpp),
      callback: function($$v) {
        _vm.$set(_vm.customer, "kpp", $$v)
      },
      expression: "customer.kpp"
    }
  }) : _vm._e()], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.customer && parseInt(_vm.customer.type) === 2),
      expression: "customer && parseInt(customer.type) === 2"
    }]
  }, [_c('ZInputAutocomplete', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ((parseInt(_vm.customer.type) === 2 ? 'required' : '')),
      expression: "(parseInt(customer.type) === 2 ? 'required' : '')"
    }],
    ref: "passport",
    attrs: {
      "update-on-input": true,
      "label": "Номер паспорта",
      "items": _vm.customersFl,
      "callback": _vm.searchCustomerByPassport,
      "length-on-search": 4,
      "display-property": "passport_number",
      "display-property-list": "fl_passport_label",
      "property": "passport_number",
      "name": "recipient_passport_number",
      "id": "recipient_passport_number",
      "default": _vm.customer.passport_number,
      "mask": "99 99 999999",
      "required": (parseInt(_vm.customer.type) === 2 ? true : false),
      "validate": "passport",
      "error": _vm.errors.first('recipient_passport_number'),
      "data-vv-name": "recipient_passport_number",
      "data-vv-as": ' ',
      "disabled": _vm.blocked,
      "inline": "inline",
      "dirty": _vm.dirtyObj.passport
    },
    on: {
      "select": _vm.selectCustomer,
      "clear": _vm.clearCustomer,
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "passport", $event)
      }
    },
    model: {
      value: (_vm.customer.passport_number),
      callback: function($$v) {
        _vm.$set(_vm.customer, "passport_number", $$v)
      },
      expression: "customer.passport_number"
    }
  }), _c('z-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasPassport),
      expression: "hasPassport"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "ФИО",
      "name": "recipient_fio",
      "id": "recipient_fio",
      "required": true,
      "disabled": !_vm.customer.allow_edit || _vm.blocked,
      "error": _vm.errors.first('recipient_fio'),
      "data-vv-name": "recipient_fio",
      "data-vv-as": ' ',
      "inline": "inline",
      "dirty": _vm.dirtyObj.name
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "name", $event)
      }
    },
    model: {
      value: (_vm.customer.name),
      callback: function($$v) {
        _vm.$set(_vm.customer, "name", $$v)
      },
      expression: "customer.name"
    }
  })], 1), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:1|max:1000'),
      expression: "'min:1|max:1000'"
    }],
    attrs: {
      "label": "Адрес для документов",
      "id": "recipient_docaddress",
      "name": "recipient_docaddress",
      "disabled": _vm.blocked,
      "data-vv-as": ' ',
      "error": _vm.errors.first('doc_address'),
      "dirty": _vm.dirtyObj.doc_address,
      "inline": "inline"
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "doc_address", $event)
      }
    },
    model: {
      value: (_vm.customer.doc_address),
      callback: function($$v) {
        _vm.$set(_vm.customer, "doc_address", $$v)
      },
      expression: "customer.doc_address"
    }
  }), _c('multy-autocomplete', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasInn || _vm.hasPassport),
      expression: "hasInn || hasPassport"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "contact",
    attrs: {
      "placeholder": "Контактное лицо",
      "label": "Контактное лицо",
      "display-property": "label",
      "property": "name",
      "return": "id",
      "showOnFocus": true,
      "items": _vm.contacts,
      "show-search-input": false,
      "required": true,
      "can-add": true,
      "id": "recipient_contact",
      "name": "recipient_contact",
      "error": _vm.errors.first('recipient_contact'),
      "data-vv-name": "recipient_contact",
      "data-vv-as": ' ',
      "tolltip-fields": {
        phone: 'Тел',
        email: 'E-mail'
      },
      "inline": "inline",
      "dirty": _vm.dirtyObj.contacts
    },
    on: {
      "select": _vm.selectContact,
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "contacts", $event)
      }
    },
    model: {
      value: (_vm.customer.attached_contacts),
      callback: function($$v) {
        _vm.$set(_vm.customer, "attached_contacts", $$v)
      },
      expression: "customer.attached_contacts"
    }
  }, [_c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_spaces'),
      expression: "'required|alpha_spaces'"
    }],
    attrs: {
      "name": "recipient_contact_name",
      "id": "recipient_contact_name",
      "label": "Имя",
      "required": "required",
      "error": _vm.errors.first('contact.recipient_contact_name'),
      "data-vv-name": "recipient_contact_name",
      "data-vv-as": ' ',
      "data-vv-scope": "contact"
    },
    model: {
      value: (_vm.newContact.name),
      callback: function($$v) {
        _vm.$set(_vm.newContact, "name", $$v)
      },
      expression: "newContact.name"
    }
  }), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/
      }),
      expression: "{required: true, regex: /^\\+7 \\(\\d{3}\\) \\d{3}-\\d{2}-\\d{2}$/ }"
    }],
    attrs: {
      "name": "recipient_contact_phone",
      "id": "recipient_contact_phone",
      "label": "Телефон",
      "mask": "+7 (999) 999-99-99",
      "error": _vm.errors.first('contact.recipient_contact_phone'),
      "data-vv-name": "recipient_contact_phone",
      "data-vv-as": ' ',
      "data-vv-scope": "contact"
    },
    model: {
      value: (_vm.newContact.phone),
      callback: function($$v) {
        _vm.$set(_vm.newContact, "phone", $$v)
      },
      expression: "newContact.phone"
    }
  }), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('email'),
      expression: "'email'"
    }],
    attrs: {
      "name": "recipient_contact_email",
      "id": "recipient_contact_email",
      "label": "E-mail",
      "error": _vm.errors.first('contact.recipient_contact_email'),
      "data-vv-name": "recipient_contact_email",
      "data-vv-as": ' ',
      "data-vv-scope": "contact"
    },
    model: {
      value: (_vm.newContact.email),
      callback: function($$v) {
        _vm.$set(_vm.newContact, "email", $$v)
      },
      expression: "newContact.email"
    }
  }), _c('md-button', {
    staticClass: "md-primary md-dense",
    on: {
      "click": _vm.saveContact
    }
  }, [_vm._v("Сохранить")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4acc8450","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/deals/views/components/Recipient.vue
// module id = 1128
// module chunks = 0